import foodImg from '@asset/images/login/dining@2x.png';
import hotelImg from '@asset/images/login/hotel@2x.png';
import travelImg from '@asset/images/login/travel@2x.png';
import carImg from '@asset/images/login/car@2x.png';

export const Carousels = [
    { backgroundImage: `url(${foodImg})` },
    { backgroundImage: `url(${hotelImg})` },
    { backgroundImage: `url(${travelImg})` },
    { backgroundImage: `url(${carImg})` },
];

export const PHONE_LENGTH = 11;

export const CAPCHA_LENGTH = 6;

export const TIMER = 60;

export const INTERVAL = 1000;

export const COUNTRY_CODE = '+86'; // +1264 测试用，手机号随便填，验证码手机号后6位；'+86' 线上用

export function isNumber(value) {
    return /^\d*$/.test(value);
}

export const PHONE_ERRMSG = '请输入正确的手机号';

export const CAPCHA_ERRMSG = '验证码错误';
